import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducers'

import createSagaMiddleware from 'redux-saga'

import { watchEvents } from './sagas'

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
  devTools: process.env.REACT_APP_ENV !== 'production'
})

sagaMiddleware.run(watchEvents)
